<!-- ############################################## -->
<!-- ############# Sección de HTML ################ -->
<!-- ############################################## -->
<!-- 
	Definicion de la vista App, altamente flexible y personalizado,
	construida sobre los cimientos de la mejora progresiva y reactiva,
	agrega caracteristicas de diseño en la presentancion de contenido de la aplicacion 
 -->
<template>
  <v-app class="famisoftApp">
     <!-- Zona de notificaciones -->
      <v-snackbar class="notificaciones" v-model="notification.visible" :color="notification.color" :timeout="6000" top multi-line dark>
        {{notification.message}}
        <v-btn color="white" @click="hideNotification" class="ma-2" small dark outlined>Cerrar</v-btn>
      </v-snackbar>
      <component class="famisoftComponente" :is="layout">
          <router-view/>
      </component>
  </v-app>
</template>


<!-- ############################################## -->
<!-- ############# Seccion de Script ############## -->
<!-- ############################################## -->
<!-- 
	Espacio que permite la configuracion y definicion de propiedades, datos, metodos entre otros, determina 
	el comportamiento de la vista y su ciclo de vida  
 -->
<script>

  /**Definicion de componentes o librerias necesarioas que se complementan con la vista */
  import { mapState, mapMutations, mapActions } from 'vuex'

  /**
    * Definimos el modulo propio de la vista, basado en las directivas de vuejs
    */
  export default {

    /**
		 * Metodo que se ejecuta al crear la vista, hace parte del ciclo de vida de vuejs 
		 */
    created () {

      /**Verificar si el usuario se encuentra autenticado */
      this.checkAuthentication();
    }, 
    
    /**
		 * Objecto que permite registrar funciones y se almacenan en cache, hacen parte de la capa de negocio del componente 
		 */
    computed: {

      /**Se inyecta metodos que hacen parte del estado de notificaciones */
      ...mapState('Notifications', ['notification']), 

      /**Se inyecta metodos que hacen parte del estado de sesion */
      ...mapState('Session', ['permission']),

      /**Metodo que define el diseño de presentancion del contenido */
      layout () {
        return (this.$route.meta.layout || 'default') + '-layout'
      }
    }, 

    /**
		 * Objecto que permite registrar las funciones que hacen parte de la capa de negocio del componente 
		 */
    methods: {

      /**Se inyecta metodos que hacen parte del estado de notificaciones */
      ...mapMutations('Notifications', ['hideNotification']),

      /**Se inyecta metodos que hacen parte del estado de sesion */
      ...mapMutations('Session', ['SET_USER', 'SET_PERMISSION']),

      /**Se inyecta acciones que hacen parte del estado de sesion */
      ...mapActions('Session', ['loadPermission', 'loadPermission2']),

      /**Metodo que permite verificar si el usuario se encuetnra autenticado */
      checkAuthentication()  {
        if (this._.isEmpty(this.permission) && this.$jwt.hasToken()) {
          let usuario = this.$jwt.decode().usuario;
          this.SET_USER(usuario);
          this.loadPermission();
        }
      }
    }
  }
</script>